import { InitializeOptions } from 'react-ga'
import { isTest } from '../Utils'

const ReactGAOptions: InitializeOptions = {
  testMode: isTest(),
}

export default {
  trackingCode: process.env.REACT_APP_ANALYTICS_TRACKING_CODE || '',
  options: ReactGAOptions,
}
